<!-- open up the component button -->
<div class="icon-wrapper" (click)="open(content)"><ng-content icon></ng-content><ng-content title></ng-content></div>

<ng-template #content let-modal >
  <div class="modal-header {{color}}" [class.hideDialog]="hideDialog">
    <div class="container-fluid">
      <div class="row modal-header-row">
        <div class="modal-icon icon fill-white" aria-label="logo" [inlineSVG]="iconSrc"></div>
        <span class="modal-title" id="modal-basic-title">{{title | translate}}</span>
        <div class="modal-icon icon fill-white close-icon" (click)="close()" aria-label="close" [inlineSVG]="'assets/ico/close-24px.svg'"></div>
      </div>
    </div>
  </div>
  <div class="modal-body p-0">
      <ng-content select="[content]"></ng-content>
  </div>
    <ng-content select="[collapsable]"></ng-content>
</ng-template>
